import * as React from 'react'

import LectureDetail from '../../lecture/LectureDetail'
import RoutePrivateLecture from '../RoutePrivateLecture'

type ContextType = {
  children: any
  frontmatter: {
    title: string
    starterFilesLink: string
    video: string
    lectureTitle: string
    paid: boolean
  }
  path: string
}

const initialContext: ContextType = {
  children: null,
  frontmatter: {
    title: '',
    starterFilesLink: '',
    video: '',
    lectureTitle: '',
    paid: true,
  },
  path: '',
}

// TODO: add protected route

const LectureChildrenContext = React.createContext(initialContext)
export const { Provider, Consumer } = LectureChildrenContext

const Lecture = props => {
  const { children, path, pageContext } = props
  const { frontmatter } = pageContext
  const { title, description } = frontmatter

  const modifiedPath =
    path.indexOf('*') !== -1 ? path.replace('*', '') + props['*'] : path

  return (
    <Provider value={{ children, frontmatter, path: modifiedPath }}>
      <RoutePrivateLecture
        title={title}
        description={description}
        path={path}
        frontmatter={frontmatter}
        component={LectureDetail}
      />
    </Provider>
  )
}
export default Lecture
